import { create } from 'zustand';

const useSolarFormStore = create((set) => ({
  formData: {
    propertyType: 'Residential',
    pincode: '',
    name: '',
    phoneNumber: '',
    monthlyBill: 'upto1500',
    consent: false,
  },
  setFormData: (newFormData) =>
    set((state) => ({
      formData: { ...state.formData, ...newFormData },
    })),
  resetFormData: () =>
    set({
      formData: {
        propertyType: 'Residential',
        pincode: '',
        name: '',
        phoneNumber: '',
        monthlyBill: 'upto1500',
        consent: false,
      },
    }),
}));

export default useSolarFormStore;
